import { render, staticRenderFns } from "./UserActionInfoBlockChat.vue?vue&type=template&id=33d391ea&"
import script from "./UserActionInfoBlockChat.vue?vue&type=script&lang=js&"
export * from "./UserActionInfoBlockChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports